export default (targetId) => {

  const s = {}
  const pc = {}
  const sp = {}
  s.pc = pc;
  s.sp = sp;
  const init = () => {
    s.isBuild = false;
    s.isPcMedia = window.matchMedia('(min-width: 768px)');
    s.explore = document.getElementById('explore');
    s.root = document.getElementById(targetId);
    s.val = s.root.querySelector('.le-explore-instruction__val');
  }

  const buildSpSelect = () => {
    sp.root = s.root.querySelector('.u-disp-sp');
    sp.select = sp.root.querySelector('.le-explore-select')
    sp.target = sp.root.querySelector('.le-explore-select__target-link');
    sp.targetTxt = sp.root.querySelector('.le-explore-select__target-txt');

    bindSelectEleClickAction();
    releaseSelect(sp.select);
  }
  const bindSelectEleClickAction = () => {
    sp.selectEle = sp.root.querySelector('.le-explore-select__select');

    sp.selectEle.addEventListener('focus', focusSelectAction)
    sp.selectEle.addEventListener('blur', blurSelectAction)
    sp.selectEle.addEventListener('change', changeSelectAction);
    sp.existSelectAction = true;

    if (s.clickCb) {
      s.clickCb();
    }
  }
  const unbindSelectEleClickAction = () => {
    if (sp.existSelectAction) {
      sp.selectEle.removeEventListener('focus', focusSelectAction)
      sp.selectEle.removeEventListener('blur', blurSelectAction)
      sp.selectEle.removeEventListener('change', changeSelectAction);
    }
  }
  const focusSelectAction = () => {
    sp.select.classList.add('is-active')
  }
  const blurSelectAction = () => {
    sp.select.classList.remove('is-active')
  }
  const changeSelectAction = () => {
    const val = sp.selectEle.value;
    const selectedOption = [].filter.call(sp.selectEle.children, option => option.selected)[0]
    sp.targetTxt.textContent = selectedOption.textContent;

    setVal(val);
    sp.select.classList.remove('is-active');

    const noValueOptions = [].filter.call(sp.selectEle.children, option => option.value == '');
    if (noValueOptions.length) {
      noValueOptions.forEach(option => option.remove());
    }
  }

  const buildPcSelect = () => {
    pc.root = s.root.querySelector('.u-disp-pc');
    pc.select = pc.root.querySelector('.le-explore-select')
    pc.target = pc.root.querySelector('.le-explore-select__target-link');
    pc.targetTxt = pc.root.querySelector('.le-explore-select__target-txt');

    bindTargetClickAction();
    bindListClickAction();
  }

  const releaseSelect = () => {
    if (s.data.length == 0) {
      return;
    }
    s.root.querySelectorAll('.le-explore-select').forEach(select => select.classList.remove('_disabled'))
  }
  const rockSelect = () => {
    s.root.querySelectorAll('.le-explore-select').forEach(select => select.classList.add('_disabled'))
  }

  const bindListClickAction = () => {
    pc.selectList = pc.root.querySelector('.le-explore-select__list');
    pc.selectLinks = pc.selectList.querySelectorAll('.le-explore-select__list-link');
    pc.selectLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const val = link.dataset.val;
        pc.targetTxt.textContent = link.textContent;

        setVal(val);
        closeListAction();
      })
    })
  }
  const bindTargetClickAction = () => {
    pc.selectListBody = pc.root.querySelector('.le-explore-select__body');
    pc.scrollEntity = pc.root.querySelector('.le-explore-select__choice-inner');
    pc.scrollArea = pc.root.querySelector('.le-explore-select__choice');
    pc.rail = pc.root.querySelector('.le-explore-select__scrollbar');
    pc.target.addEventListener('click', clickTargetAction);
    pc.existClickTargetAction = true
  }
  const unbindTargetClickAction = () => {
    if (pc.existClickTargetAction) {
      pc.target.removeEventListener('click', clickTargetAction);
    }
  }
  const clickTargetAction = (e) => {
    e.preventDefault();
    if (!s.isPcMedia.matches) {
      return;
    }

    if (pc.select.classList.contains('is-active')) {
      closeListAction();
    } else {
      openListAction();
    }

    if (s.clickCb) {
      s.clickCb();
    }
  }
  const openListAction = () => {
    const lh = pc.scrollEntity.clientHeight;
    pc.selectListBody.style.height = `${lh}px`;

    if (pc.selectListBody.clientHeight < lh) {
      buildScrollbar();
    } else {
      hiddenScrollbar();
    }

    pc.select.classList.add('is-active')
  }
  const closeListAction = () => {
    pc.selectListBody.style.height = '';
    pc.select.classList.remove('is-active')

    if (pc.rail.classList.contains('is-visible')) {
      destroyScrollbar();
    }
  }
  const buildScrollbar = () => {
    pc.rail.classList.add('is-visible');

    const rail = pc.scrollArea.querySelector('.le-explore-select__scrollbar-rail');
    const thumb = pc.scrollArea.querySelector('.le-explore-select__scrollbar-thumb');
    pc.scrollAction = (evt) => {
      const rate = evt.target.scrollTop / (evt.target.scrollHeight - pc.scrollArea.clientHeight)
      const setTranslateY = (rail.clientHeight - thumb.clientHeight) * rate
      thumb.style.transform = `translateY(${setTranslateY}px)`
    }

    pc.scrollArea.addEventListener('scroll', pc.scrollAction, false)
    pc.existScrollAction = true;
  }
  const destroyScrollbar = () => {
    if (pc.existScrollAction) {
      pc.scrollArea.removeEventListener('scroll', pc.scrollAction)
    }
  }
  const hiddenScrollbar = () => {
    pc.rail.classList.remove('is-visible');
  }


  const setVal = (val) => {
    s.val.value = val;
    if (s.changeCb && s.val.value != '') {
      s.changeCb();
    }
  }
  const getValue = () => {
    return s.val.value;
  }

  const buildList = () => {
    buildPcList();
    buildSpList();
  }
  const buildPcList = () => {
    pc.root = s.root.querySelector('.u-disp-pc');

    if (s.data.length == 0) {
      pc.root.querySelector('.le-explore-select__target-txt').textContent = "まだデータがありません";
    } else {
      pc.root.querySelector('.le-explore-select__target-txt').textContent = "選択してください";
      const list = pc.root.querySelector('.le-explore-select__list');
      const firstListItem = list.firstElementChild;

      const fragment = document.createDocumentFragment();
      s.data.forEach(item => {
        const cloneListItem = firstListItem.cloneNode(true);
        cloneListItem.querySelector('.le-explore-select__list-link').dataset.val = item.value;
        cloneListItem.querySelector('.le-explore-select__list-txt').textContent = item.text;

        fragment.appendChild(cloneListItem);
      })
      list.innerHTML = '';
      list.appendChild(fragment);
    }
  }
  const buildSpList = () => {
    sp.root = s.root.querySelector('.u-disp-sp');

    if (s.data.length == 0) {
      sp.root.querySelector('.le-explore-select__target-txt').textContent = "まだデータがありません";
    } else {
      sp.root.querySelector('.le-explore-select__target-txt').textContent = "選択してください";
      const select = sp.root.querySelector('.le-explore-select__select');

      const fragment = document.createDocumentFragment();
      fragment.appendChild(createOption('', '選択してください'))
      s.data.forEach(item => {
        fragment.appendChild(createOption(item.value, item.text));
      })
      select.innerHTML = '';
      select.appendChild(fragment);
    }
  }
  const createOption = (v, t) => {
    const option = document.createElement('option');
    option.value = v;
    option.textContent = t;

    return option;
  }


  const build = (data) => {
    if (s.isBuild) {
      destroy();
    }
    s.data = data;
    buildList(data);
    buildPcSelect();
    buildSpSelect();
    releaseSelect();

    s.isBuild = true;
  }
  const destroy = () => {
    s.isBuild = false;
    rockSelect();
    unbindSelectEleClickAction();
    unbindTargetClickAction();
    setVal('');

    if (pc.select && pc.select.classList.contains('is-active')) {
      closeListAction();
    }
  }

  const onChange = (cb) => {
    s.changeCb = cb;
  }
  const onClick = (cb) => {
    s.clickCb = cb;
  }

  init();

  return {
    build,
    destroy,
    onChange,
    getValue,
    onClick
  }
}
